import React, { Component } from "react";
import { Checkbox, Alert, Icon, Row } from "antd";
import Login from "components/Login";
import styles from "./index.module.less";
import UserLayout from "layouts/UserLayout";
import { inject, observer } from "mobx-react";
import SliderCaptcha from "common/captcha";
import _ from "lodash";
import "common/captcha.css";
import ReCAPTCHA from "components/ReCAPTCHA";
import { encrypt, decrypt } from "common/abc";
import co from "co";

const { Tab, UserName, Password, Mobile, Captcha, Submit } = Login;

@inject("rootStore")
@observer
export default class LoginPage extends Component {
	constructor(props) {
		super(props);
		this.requireCaptcha = false;
		this._reCaptchaRef = React.createRef();
		this.captchaType = "v2";
	}

	recaptchaResponse = "";

	state = {
		type: "account",
		autoLogin: true
	};

	componentDidMount() {
		// let $this = document.getElementById("captcha");
		// new SliderCaptcha($this, {
		// 	id: 'captcha',
		// 	width: 400,
		// 	height: 200,
		// 	sliderL: _.random(30, 40),
		// 	sliderR: _.random(5, 9),
		// 	offset: 5,
		// 	loadingText: 'Loading...',
		// 	failedText: 'Try again',
		// 	barText: 'Slide to solve the captcha',
		// 	repeatIcon: 'fa fa-redo',
		// 	setSrc: function () {
				
		// 	},
		// 	onSuccess: function () {
				
		// 	},
		// 	onFail: function () {
	
		// 	},
		// 	onRefresh: function () {
			
		// 	}
		// });
	}

	onTabChange = type => {
		this.setState({ type });
	};

	handleSubmit = (err, values) => {
		const { type } = this.state;
		const {
			rootStore: { userStore }
    } = this.props;
        
		if (!err) {	
			co(
				function*() {										
					var startTime = Date.now();
					if (this.requireCaptcha) {	
						if (this.captchaType === "invisible") {					
							console.log("Start time", startTime);
							const response = yield this._reCaptchaRef.current.executeAsync();
							console.log("Done");
							this._reCaptchaRef.current.reset();
							var endTime = Date.now();
							console.log("End time", endTime);
							if (endTime - startTime > 60 * 1000) {
								userStore.changeStatus("Timed out");						
							} else {
								var captcha = encrypt(response);
								userStore.remoteLogin({...values, type, captcha});		
							}
						} else if (this.captchaType === "v2") {
							if (!this.recaptchaResponse) {
								userStore.changeStatus("Please solve the captcha");								
							} else {
								var captcha = encrypt(this.recaptchaResponse);
								this._reCaptchaRef.current.reset();
								this.recaptchaResponse = "";
								userStore.remoteLogin({...values, type, captcha});		
							}
						}
					} else {
						userStore.remoteLogin({...values, type});		
					}
				}.bind(this)
			);				
			// var el = document.getElementById("g-recaptcha-response");
			// var captcha = this.recaptchaResponse;
      		// userStore.remoteLogin({...values, type, captcha})			
		}
	};

	changeAutoLogin = e => {
		this.setState({
			autoLogin: e.target.checked
		});
	};

	renderMessage = content => {
		return (
			<Alert
				style={{ marginBottom: 24 }}
				message={content}
				type="error"
				showIcon
			/>
		);
	};

	onChange = (value) => {		
		console.log("Changed");
		this.recaptchaResponse = encrypt(value);
	}

	render() {		
		var rxss = decrypt(window.rxss);
		this.captchaType = decrypt(window.type);

		if (rxss === "true") {
			this.requireCaptcha = true;
		} else {
			this.requireCaptcha = false;
		}

		var rk = decrypt(window.rk);

		const {
			rootStore: { userStore }
		} = this.props;
		const { type } = this.state;	

		let errorMessage = "";
		if (userStore.status != null && userStore.status != "ok") {
			errorMessage = this.renderMessage(userStore.status);
		} else {
		}

		const comp = (
			<div className={styles.main}>
				<Login
					defaultActiveKey={type}
					onTabChange={this.onTabChange}
					onSubmit={this.handleSubmit}
				>
					{errorMessage}
					<UserName name="username" placeholder="email/iloverankerx@gmail.com" />
					<Password name="password" placeholder="password/yes" />
					{/* <Row><div id="captcha"></div></Row> */}
					{this.requireCaptcha ? <ReCAPTCHA
						sitekey={rk}
						size={this.captchaType == "v2" ? "normal" : "invisible"}
						ref={this._reCaptchaRef}
						onChange={this.onChange}
  					/> : ""}
					{/* <div>
						<Checkbox
							checked={this.state.autoLogin}
							onChange={this.changeAutoLogin}
						>
							Auto Login
						</Checkbox>
						<a style={{ float: "right" }} href="">
							Forgot Password
						</a>
					</div> */}
					<Submit loading={false}>Login</Submit>
				</Login>
			</div>
		);
		return <UserLayout>{comp}</UserLayout>;
	}
}
